/* =============================================================================
   cro-sticky-buy.js: show / hide for a bottom sticky buy bar (CRO plan, 2026-09-15).
   Drives sections/undepleted-sticky-buy.liquid (homepage, below lg) and is ready for a
   product-page bar. Contract, on the bar element [data-cro-sticky]:
     data-sticky-show-after  CSS selector. The bar may show once this element has scrolled
                             up out of view (under the sticky header counts as out of view).
                             Without the attribute the bar may show at once.
     data-sticky-hide-when   Comma-separated selectors. The bar hides while ANY of them is on
                             screen (homepage: "#offer,#contact").
   The bar ships hidden: "translate-y-full invisible", aria-hidden="true", inert. Showing swaps
   in "translate-y-0 visible" and drops aria-hidden + inert; the slide is the bar's own
   transition classes (--dur / --ease), which motion-reduce:transition-none and the global
   prefers-reduced-motion rule cut to nothing. No IntersectionObserver = the bar stays hidden
   and the page works exactly as before.
   Class names are written out in full so Tailwind emits them.
   ========================================================================== */
(function () {
  'use strict';

  var HIDDEN = ['translate-y-full', 'invisible'];
  var SHOWN = ['translate-y-0', 'visible'];

  function query(selector) {
    try {
      return document.querySelector(selector);
    } catch (e) {
      return null;
    }
  }

  function init(bar) {
    if (!bar || bar.__croSticky) return;
    if (!('IntersectionObserver' in window)) return;
    bar.__croSticky = true;

    var showSelector = bar.getAttribute('data-sticky-show-after');
    var trigger = showSelector ? query(showSelector) : null;
    var hideEls = [];
    (bar.getAttribute('data-sticky-hide-when') || '').split(',').forEach(function (selector) {
      selector = selector.trim();
      var el = selector ? query(selector) : null;
      if (el) hideEls.push(el);
    });

    var past = !showSelector; // may the bar show yet?
    var inView = hideEls.map(function () {
      return false;
    });
    var shown = false;

    function set(show) {
      if (show === shown) return;
      shown = show;
      if (show) {
        bar.classList.remove(HIDDEN[0], HIDDEN[1]);
        bar.classList.add(SHOWN[0], SHOWN[1]);
        bar.removeAttribute('aria-hidden');
        bar.removeAttribute('inert');
      } else {
        if (bar.contains(document.activeElement)) document.activeElement.blur();
        bar.classList.remove(SHOWN[0], SHOWN[1]);
        bar.classList.add(HIDDEN[0], HIDDEN[1]);
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      }
    }

    function update() {
      var hiding = inView.some(Boolean);
      set(past && !hiding);
    }

    if (trigger) {
      // The sticky header covers the top of the viewport: shrink the root by its height so
      // "under the header" counts as scrolled away.
      var header = document.querySelector('header.header');
      var top = header ? Math.round(header.getBoundingClientRect().height) : 0;
      new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          var rootTop = entry.rootBounds ? entry.rootBounds.top : top;
          past = !entry.isIntersecting && entry.boundingClientRect.bottom <= rootTop + 1;
          update();
        },
        {rootMargin: '-' + top + 'px 0px 0px 0px'},
      ).observe(trigger);
    } else if (showSelector) {
      // The trigger is missing: fall back to "after the first screen".
      var onScroll = function () {
        var next = window.scrollY > window.innerHeight * 0.8;
        if (next !== past) {
          past = next;
          update();
        }
      };
      window.addEventListener('scroll', onScroll, {passive: true});
      onScroll();
    }

    hideEls.forEach(function (el, index) {
      new IntersectionObserver(function (entries) {
        inView[index] = entries[entries.length - 1].isIntersecting;
        update();
      }).observe(el);
    });

    update();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cro-sticky]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Theme editor re-renders a section in place; bind the fresh markup.
  document.addEventListener('shopify:section:load', initAll);
})();
